import { createSlice } from "../helper";

const leftNavSlice = createSlice({
    name: 'LeftNav',
    initialState: {
      sections: [],
      isSlimView: false
    },
    reducers:{
      updateExpandedTabId: (state, action) => {
        state.expandedTabId = action.payload.tabId
      },
      updateInitialData: (state,action) => {
        state.sections = action.payload.sections
      },
      toggleSlimView: (state) => {
        state.isSlimView = !state.isSlimView
      },
      setSlimView: (state, action) => {
        state.isSlimView = action.payload
      }
    }
})

export const leftNavActions =  leftNavSlice.actions;

export default leftNavSlice;

